import React from 'react'
import { IconButton, InputAdornment, InputLabel, OutlinedInput, OutlinedInputProps, FormControl } from '@mui/material'
import { J2Copy } from '@e3dc-react/icons'
import { useCopyToClipboard } from './hook/use-copy-to-clipboard'

type Props = Omit<OutlinedInputProps, 'value' | 'label'> & {
  value: string
  label: string
  /** allow value displayed be different then the one to be copied */
  valueToCopy?: string
  iconColor?: string
}

/**
 * Displays value in TextField and allows the user to copy value to the clipboard
 */
const CopyToClipboard: React.FC<Props> = ({ value, label, valueToCopy, iconColor, ...props }) => {
  const { copyToClipboard } = useCopyToClipboard()

  const handleCopyToClipboard = async (): Promise<void> => {
    copyToClipboard(valueToCopy ?? value)
  }

  return (
    <FormControl>
      <InputLabel>{label}</InputLabel>
      <OutlinedInput
        label={label}
        value={value}
        {...props}
        endAdornment={
          <InputAdornment position="end">
            <IconButton onClick={handleCopyToClipboard}>
              <J2Copy sx={{ color: iconColor ?? 'primary.main' }} />
            </IconButton>
          </InputAdornment>
        }
      />
    </FormControl>
  )
}

export default CopyToClipboard
